import React, { FC } from 'react'
import { ErrorPage } from './ErrorPage'

export const Page_403Component: FC = () => {
	return (
		<ErrorPage
			advice="Перейдите на стартовую страницу или обратитесь в&nbsp;поддержку."
			errorCode={403}
			title="У Вас нет прав на просмотр содержимого страницы..."
		/>
	)
}
